import { PricingList } from '@micro-apps/stores';

type Props = {
	pricingList?: PricingList;
	pricingListDisclaimer?: string | null;
};

const PriceListContent = ({ pricingList, pricingListDisclaimer }: Props) => {
	return (
		<>
			{pricingListDisclaimer && (
				<div className="WarningModal-content-subtitle ty-b3" style={{ marginTop: '10px' }}>
					{pricingListDisclaimer}
				</div>
			)}
			{pricingList?.map(({ label, secondaryLabel, prices = [] }) => (
				<div className="WarningModal-content-nestedList content" key={label}>
					<div className="WarningModal-listitem-container">
						<span className="WarningModal-heading ty-c1">{label}</span>
						{secondaryLabel && (
							<div className="WarningModal-heading-subtitle ty-d4" style={{ marginTop: '5px' }}>
								{secondaryLabel}
							</div>
						)}
						{prices.map(price => (
							<div
								className="WarningModal-nested-container"
								key={price.label}
								style={{ display: 'flex', paddingBottom: 0 }}
							>
								<span className="WarningModal-nested-label ty-c2">{price.label}</span>
								<span className="WarningModal-nested-value ty-c1">{price.amount}</span>
							</div>
						))}
					</div>
				</div>
			))}
		</>
	);
};

export default PriceListContent;
